// extracted by mini-css-extract-plugin
module.exports = {"root":"document-html_root__83im2","content":"document-html_content__IGdL2","variationsBlock":"document-html_variationsBlock__uLEbt","buttons":"document-html_buttons__dToKE"};